export const DESIGNER_STYLE_DIRECTIONS = [
  "Casual Chic",
  "Business Formal",
  "Street Style",
  "Minimalist",
  "Bohemian",
  "Sporty Luxe",
  "Evening Glam",
  "Smart Casual",
];

export const DESIGNER_MOODS = [
  "Confident",
  "Playful",
  "Mysterious",
  "Romantic",
  "Edgy",
  "Effortless",
  "Bold",
  "Relaxed",
];

export const GAP_SEASONS = ["Spring", "Summer", "Fall", "Winter"];
